// extracted by mini-css-extract-plugin
export var BlogPost = "f_h";
export var aniSpin = "f_d";